import React, { Component } from 'react'
import Newsletter from '../../containers/NewsletterWidget'
import News from '../PageHome/components/Noticias'
import HotelesList from './components/HotelList.component'
import Brokers from '../../components/Brokers'
import ContactForm from '../commons/ContactForm/ContactForm.component'
import Imis from '../commons/SliderMarketReports/imi'
import { translate } from 'react-translate'
import Services from '../../components/Services'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'

@translate('Hoteles')
class Hoteles extends Component {

  UNSAFE_componentWillMount() {
    window.scrollTo(0, 0)
    this.props.didMount({ id: '13', name: 'Hoteles'})
    this.props.setPhone()
    this.props.getHotelsList()
    this.props.loadNewsBySector()
    this.props.loadDirectors()
  }

  render () {

    const { hotels, news, directors, brokers, imis, onChangeOrder, order, t, services } = this.props
    const title = t('Titulo')
    return (
      <div className='container-fluid'>
        <MainBanner
          backgroundURL={'/assets/images/hoteles-search.jpg'}
          mainTitle={t('Division_Hoteles')}
          secondaryTitle={t('Secondary_title')}
        >
        </MainBanner>
        <Services services={services}/>
        <div className='hoteles-container'>
          <HotelesList hotels={hotels} onChangeOrder={onChangeOrder} order={order}/>
        </div>

        <div className='form-container'>
          <ContactForm section={title}/>
        </div>

        {/* { ((directors || []).concat(brokers || []).length > 0) ? (
          <div className='brokers-container'>
            <Brokers brokers={(directors || []).concat(brokers || [])} section={title} />
          </div>
        ) : '' } */}

        {(imis.length > 0) ?
          <div className='imis-container'>
            <Imis imis={imis}/>
          </div>: '' }
        <div className='form-newsletter-container'>
          <Newsletter />
        </div>
        {(news.length > 0) ?
          <News news={news} />
        : '' }
      </div>
    )
  }
}

export default Hoteles



// WEBPACK FOOTER //
// ./src/features/PageHotels/PageHotels.component.js